import React from "react";

interface ConditionalDisplayProps {
  condition: boolean;
  children: React.ReactNode;
}

export const ConditionalDisplay = ({
  condition = true,
  children,
}: ConditionalDisplayProps) => {
  return <>{condition ? children : null}</>;
};
